/** Curated Wikimedia Commons press/portrait photos for Ari demo roster cards. */
export const ARI_CLIENT_ROSTER_PHOTOS: Record<string, string> = {
  "jay-z":
    "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Jay-Z_%40_Shawn_%27Jay-Z%27_Carter_Foundation_Carnival_%28crop_2%29.jpg/960px-Jay-Z_%40_Shawn_%27Jay-Z%27_Carter_Foundation_Carnival_%28crop_2%29.jpg",
  rihanna:
    "https://assets.vogue.com/photos/665f50c05aa2055fb127cb65/master/w_2560%2Cc_limit/2150388270",
  lebron:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/LeBron_James_%2851914946203%29_%28cropped%29.jpg/960px-LeBron_James_%2851914946203%29_%28cropped%29.jpg",
  kobe:
    "https://static.independent.co.uk/s3fs-public/thumbnails/image/2018/09/29/16/kobe-bryant.jpg",
  beyonce:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Beyonce_Knowles_with_necklaces_%28cropped_2x3%29.jpg/960px-Beyonce_Knowles_with_necklaces_%28cropped_2x3%29.jpg",
  travis:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Travis_Scott_The_DAMN._Tour_%28cropped%29.jpg/960px-Travis_Scott_The_DAMN._Tour_%28cropped%29.jpg",
  serena:
    "https://www.becauseofthemwecan.com/wp-content/uploads/2026/02/Serena-Williams-2-674x1024.jpg",
};

/** @deprecated Use ARI_CLIENT_ROSTER_PHOTOS — kept for barrel export compatibility. */
export const ARI_CLIENT_WIKI_PAGES: Record<string, string> = {
  "jay-z": "Jay-Z",
  rihanna: "Rihanna",
  lebron: "LeBron_James",
  kobe: "Kobe_Bryant",
  beyonce: "Beyoncé",
  travis: "Travis_Scott",
  serena: "Serena_Williams",
};

export function getAriClientAvatarUrl(
  clientId: string,
  rosterPhotos: Record<string, string>,
  fallback: string,
): string {
  return rosterPhotos[clientId] ?? fallback;
}

/** Returns curated roster client photos (Wikimedia Commons press portraits). */
export function useAriWikiImages(): Record<string, string> {
  return ARI_CLIENT_ROSTER_PHOTOS;
}
